import { cn } from "@/lib/utils";

interface ImageCellProps {
  src?: string;
  alt: string;
  size?: number;
  rounded?: "sm" | "md" | "lg" | "full";
  fallback?: string;
}

const roundedMap = {
  sm: "rounded",
  md: "rounded-md",
  lg: "rounded-lg",
  full: "rounded-full",
} as const;

export function ImageCell({
  src,
  alt,
  size = 36,
  rounded = "md",
  fallback = "IMG",
}: ImageCellProps) {
  return (
    <div
      className={cn("shrink-0 overflow-hidden bg-(--color-surface-muted)", roundedMap[rounded])}
      style={{ width: size, height: size }}
    >
      {src ? (
        <img src={src} alt={alt} className="h-full w-full object-cover" />
      ) : (
        <div
          className="flex h-full w-full items-center justify-center text-(--color-text-secondary)"
          style={{ fontSize: Math.max(8, size / 5) }}
        >
          {fallback}
        </div>
      )}
    </div>
  );
}
